import { Routes } from '@angular/router';
import { unsavedChangesGuard } from '@core/guards/unsaved-changes.guard';

export const appRoutes: Routes = [
  { path: '', redirectTo: '/gezin-overzicht', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () => import('@features/home/dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: 'kind-overzicht',
    loadComponent: () =>
      import('@features/kind/kinderen-overzicht/kinderen.component').then((m) => m.KinderenComponent),
  },
  {
    path: 'kind-formulier/:gezinId/:gezinNaam',
    loadComponent: () =>
      import('@features/kind/kind-formulier/kindformulier.component').then((m) => m.KindformulierComponent),
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'kind-details/:id',
    loadComponent: () =>
      import('@features/kind/kind-details/kind-details.component').then((m) => m.KindDetailsComponent),
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'gezin-overzicht',
    loadComponent: () =>
      import('@features/family/family-overview/family-overview.component').then((m) => m.FamilyOverviewComponent),
  },
  {
    path: 'gezin-formulier',
    loadComponent: () =>
      import('@features/family/family-form/family-form.component').then((m) => m.FamilyFormComponent),
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'gezin-details/:id',
    loadComponent: () =>
      import('@features/family/family-details/family-details.component').then((m) => m.FamilyDetailsComponent),
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'lijsten',
    loadComponent: () =>
      import('@features/aanwezigheidslijsten/lijsten/lijsten.component').then((m) => m.LijstenComponent),
  },
  {
    path: 'aanwezigheidsLijst/speelplein/:datum',
    loadComponent: () =>
      import('@features/aanwezigheidslijsten/aanwezigheids-lijst-speelplein/aanwezigheids-lijst-speelplein.component').then(
        (m) => m.AanwezigheidsLijstSpeelpleinComponent,
      ),
  },
  {
    path: 'aanwezigheidsLijst/:datum/:school',
    loadComponent: () =>
      import('@features/aanwezigheidslijsten/aanwezigheids-lijst/aanwezigheids-lijst.component').then(
        (m) => m.AanwezigheidsLijstComponent,
      ),
  },
  {
    path: 'aanwezigheidsLijst/:datum',
    loadComponent: () =>
      import('@features/aanwezigheidslijsten/aanwezigheids-lijst/aanwezigheids-lijst.component').then(
        (m) => m.AanwezigheidsLijstComponent,
      ),
  },
  {
    path: 'betaaloverzicht/:gezinId',
    loadComponent: () =>
      import('@features/kost/betaaloverzicht/betaaloverzicht.component').then((m) => m.BetaaloverzichtComponent),
  },
  {
    path: 'wachtlijstoverzicht/:type/:groep',
    loadComponent: () =>
      import('@features/wachtlijst/wachtlijst-overzicht/wachtlijst-overzicht.component').then(
        (m) => m.WachtlijstOverzichtComponent,
      ),
  },
  {
    path: 'wachtlijsten',
    loadComponent: () =>
      import('@features/wachtlijst/wachtlijst-selector/wachtlijst-selector.component').then(
        (m) => m.WachtlijstSelectorComponent,
      ),
  },
  {
    path: 'betaalhistoriek/:gezinId',
    loadComponent: () =>
      import('@features/kost/betaalhistoriek/betaalhistoriek.component').then((m) => m.BetaalhistoriekComponent),
  },
  {
    path: 'jaarrapport',
    loadComponent: () =>
      import('@features/rapport/kind-en-gezin-gezinoverzicht/kind-en-gezin-gezinoverzicht.component').then(
        (m) => m.KindEnGezinGezinoverzichtComponent,
      ),
  },
  {
    path: 'speelpleinweek/:datumString',
    loadComponent: () =>
      import('@features/speelplein/speelpleinweek/speelpleinweek.component').then((m) => m.SpeelpleinweekComponent),
  },
  {
    path: 'kosten',
    loadComponent: () =>
      import('@features/kost/kost-aanpassen/kost-aanpassen.component').then((m) => m.KostAanpassenComponent),
  },
  {
    path: 'activiteit-overzicht',
    loadComponent: () =>
      import('@features/activity/activity-overview/activity-overview.component').then(
        (m) => m.ActivityOverviewComponent,
      ),
  },
  {
    path: 'activiteit-formulier',
    loadComponent: () =>
      import('@features/activity/add-activity/add-activity.component').then((m) => m.AddActivityComponent),
  },
  {
    path: 'activiteit-details/:id',
    loadComponent: () =>
      import('@features/activity/activity-details/activity-details.component').then((m) => m.ActivityDetailsComponent),
  },
  {
    path: 'categorie-overzicht',
    loadComponent: () =>
      import('@features/category/category-overview/category-overview.component').then(
        (m) => m.CategoryOverviewComponent,
      ),
  },
  {
    path: 'schools',
    loadComponent: () =>
      import('@features/school/school-overview/school-overview.component').then((m) => m.SchoolOverviewComponent),
  },
  {
    path: 'groups',
    loadComponent: () =>
      import('@features/group/group-overview/group-overview.component').then((m) => m.GroupOverviewComponent),
  },
  {
    path: 'comments/:childId',
    loadComponent: () =>
      import('@features/comment/view-comments/view-comments.component').then((m) => m.ViewCommentsComponent),
  },
  {
    path: 'vrijwilliger-formulier',
    loadComponent: () =>
      import('@features/volunteer/volunteer-form/volunteer-form.component').then((m) => m.VolunteerFormComponent),
  },
  {
    path: 'vrijwilliger-details/:volunteerId',
    loadComponent: () =>
      import('@features/volunteer/volunteer-details/volunteer-details.component').then(
        (m) => m.VolunteerDetailsComponent,
      ),
  },
  {
    path: 'vrijwilliger-overzicht',
    loadComponent: () =>
      import('@features/volunteer/volunteer-overview/volunteer-overview.component').then(
        (m) => m.VolunteerOverviewComponent,
      ),
  },
  {
    path: 'periode-rapport',
    loadComponent: () =>
      import('@features/reports/period-report/period-report.component').then((m) => m.PeriodReportComponent),
  },
  {
    path: 'attendance-rapport',
    loadComponent: () =>
      import('@features/reports/attendance-report/attendance-report.component').then(
        (m) => m.AttendanceReportComponent,
      ),
  },
  {
    path: 'terugkerende-activiteit-formulier',
    loadComponent: () =>
      import('@features/recurring-activity/add-recurring-activity/add-recurring-activity.component').then(
        (m) => m.AddRecurringActivityComponent,
      ),
  },
  {
    path: 'terugkerende-activiteit-overzicht',
    loadComponent: () =>
      import('@features/recurring-activity/recurring-activity-overview/recurring-activity-overview.component').then(
        (m) => m.RecurringActivityOverviewComponent,
      ),
  },
  {
    path: 'user-invitation',
    loadComponent: () =>
      import('@features/user-management/user-invitation/user-invitation.component').then(
        (m) => m.UserInvitationComponent,
      ),
  },
  {
    path: 'documents',
    loadComponent: () =>
      import('@features/files/overview/file-overview.component').then((m) => m.FileOverviewComponent),
  },
  {
    path: 'self-checkin',
    loadComponent: () =>
      import('@features/kind/self-checkin/children-self-checkin.component').then((m) => m.ChildrenSelfCheckinComponent),
  },
  {
    path: 'self-checkin-volunteer',
    loadComponent: () =>
      import('@features/volunteer/self-checkin/volunteer-self-checkin.component').then(
        (m) => m.VolunteerSelfCheckinComponent,
      ),
  },
  {
    path: 'users',
    loadComponent: () =>
      import('@features/user-management/user-overview/user-overview.component').then((m) => m.UserOverviewComponent),
  },
  { path: '**', redirectTo: '/home' },
];
